import React from 'react';
import './TeamGallery.css';

export default function TeamGallery() {
  // Plaats hier echte team­foto-urls of gebruik tijdelijke placeholders.
  const team = [
    { name: 'David Coffa',   role: 'Full Stack Developer',   img: 'https://placehold.co/300?text=David' },
    { name: 'Jorick van der Have',   role: 'Full Stack Developer',   img: 'https://placehold.co/300?text=Jorick' },
    { name: 'Teaux Schul',  role: 'Social Media Manager',      img: 'https://placehold.co/300?text=Teaux' },
    { name: 'Juliette Copier',  role: 'Appointment Setter',     img: 'https://placehold.co/300?text=Juliette' },
  ];

  return (
    <section className="teamgallery-section">
      <div className="container">
        <h2 className="gallery-title mb-5">Het gezicht achter de groei</h2>

        <div className="row g-4">
          {team.map(({ name, role, img }, i) => (
            <div key={i} className="col-6 col-md-4 col-lg-3">
              <article className="member-card h-100">
                <img
                  src={img}
                  alt={name}
                  className="img-fluid w-100"
                  loading="lazy"
                />
                <div className="member-info">
                  <h3 className="member-name mb-1">{name}</h3>
                  <p className="member-role mb-0">{role}</p>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
